import { AxiosStatic } from 'axios';

import { AbstractPhoneCallGatewayWithHangupFunctionalityStrategy } from 'components/phoneCall/phoneCallGateway/AbstractPhoneCallGatewayWithHangupFunctionalityStrategy';
import { usePhoneCallStore } from 'src/stores/phoneCall';

import { DirectPhoneCallGatewayWithHangupFunctionalityStrategy } from 'src/components/phoneCall/phoneCallGateway/DirectPhoneCallGatewayWithHangupFunctionalityStrategy';
import { phoneCallProviderRequestConfig } from 'src/components/phoneCall/phoneCallGateway/phoneCallProviderRequestConfig';

import { OutgoingCallConfigurationForTheUser } from 'src/models/phoneCall';

import { CommandBus } from 'src/util/command/CommandBus';

type PhoneCallStore = ReturnType<typeof usePhoneCallStore>;

export class TapiMasterExternDirectPhoneCallGatewayWithHangupFunctionalityStrategy
	extends AbstractPhoneCallGatewayWithHangupFunctionalityStrategy
	implements DirectPhoneCallGatewayWithHangupFunctionalityStrategy
{
	private readonly axios: AxiosStatic;
	private readonly outGoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser;

	constructor(
		axios: AxiosStatic,
		phoneCallStore: PhoneCallStore,
		commandBus: CommandBus,
		authenticatedUserId: number,
		outGoingCallConfigurationForTheUser: OutgoingCallConfigurationForTheUser
	) {
		super(phoneCallStore, commandBus, authenticatedUserId);
		this.axios = axios;
		this.outGoingCallConfigurationForTheUser = outGoingCallConfigurationForTheUser;
	}

	public async makeCall(callerName: string, toNumber: string): Promise<string> {
		await this.axios.get(
			`${this.outGoingCallConfigurationForTheUser.url as string}/Makecall_${this.outGoingCallConfigurationForTheUser.terminal}_${toNumber}`,
			phoneCallProviderRequestConfig()
		);

		this.setActiveCallId(this.outGoingCallConfigurationForTheUser.terminal);
		return await this.createPhoneCall(callerName, toNumber);
	}

	public endCall(): void {
		void this.axios.get(
			`${this.outGoingCallConfigurationForTheUser.url as string}/Drop_${this.outGoingCallConfigurationForTheUser.terminal}`,
			phoneCallProviderRequestConfig()
		);

		this.clearActiveCall();
	}
}
